import { call, select, takeLatest } from 'redux-saga/effects';

import { initializePendo } from 'setup/Pendo';

import { currentTenantSelector } from 'features/authentication';

import {
  LOAD_USER_PROFILE,
} from '../constants';

/* ------------------------------- worker sagas ------------------------------- */

function* loadUserProfileWorker({ payload }) {
  const tenant = yield select(currentTenantSelector);
  yield call(initializePendo, payload.body, tenant);
}

/* ------------------------------- watcher sagas ------------------------------- */

export function* loadUserProfileWatcher() {
  yield takeLatest(LOAD_USER_PROFILE, loadUserProfileWorker);
}

// export all of the watcher sagas.
export default [
  loadUserProfileWatcher(),
];



// WEBPACK FOOTER //
// ./redux/user/sagas.js